import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-floor-unit-item',
  templateUrl: './floor-unit-item.component.html',
  styleUrls: ['./floor-unit-item.component.scss'],
})
export class FloorUnitItemComponent implements OnInit, OnDestroy {
  @Input() name: any;
  @Input() unitStatus: any;
  @Input() unitId: any;
  @Input() floorId: any;
  @Input() floorName: any;
  @Input() isNonActive: boolean | undefined;
  @Input() isLatestFirmwareAvailable: boolean | undefined;
  @Input() isLockBatteryLow: boolean | undefined;

  selected: boolean = false;
  subscription: Subscription | undefined;
  sharedData: any;

  constructor(
    private sharedDataService: SharedDataService,
    private commonService: CommonService
  ) {}

  /**
   * @description: runs on when component is initialized. This method subscribes loginservice.
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description: This method set the selected unit id and name to the shared-data-service
   * @input { unitId , unitName }
   * @output { none }
   */
  unitClickHandler(
    unitId: string,
    unitName: string,
    floorId: string,
    floorName: string
  ) {
    if (this.sharedData.selectedUnit.unitId === unitId) {
      return;
    }
    this.sharedDataService.setSelectedAccessPoint({
      accessPointId: '',
      accessPointName: '',
    });

    this.sharedDataService.setSelectedFloor({
      floorId: floorId,
      floorName: floorName,
    });

    this.sharedDataService.setSelectedUnit({
      unitId: unitId,
      unitName: unitName,
    });
  }
  /**
   * @description: runs just before component unmount. Unsubscribes the login service
   * @input {none}
   * @output {void}
   */

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
